import { useEffect, useState } from "react"
import { emptyFiltersCheck } from "../utils/emptyFiltersCheck"

export const useEmptyFiltersCheck = (filterObject) =>{
    const [emptyFilters, setEmptyFilters] = useState(true)

    useEffect(()=>{
        const val = emptyFiltersCheck(filterObject)
        setEmptyFilters(val)
    },[filterObject])

    return emptyFilters
}